<template>
  <div class="overlay" v-if="maintenance || invalidForm">
    <div class="page-lock">
      <div class="page-logo">
        <a class="brand" href="/">
          <img src="/static/pages/img/logo.png" alt="logo" />
        </a>
      </div>
      <div class="page-body">
        <div v-if="maintenance" class="lock-head">System Maintenance</div>
        <div v-if="invalidForm" class="lock-head">
          Ooops! What happened to this page?
        </div>
        <div class="lock-body maintenance-body">
          <div class="lock-cont">
            <div class="lock-item lock-item-full">
              <p class="text-center" v-html="maintenanceMessage"></p>
            </div>
          </div>
        </div>
      </div>
      <div class="page-footer-custom">
        © {{ getCurrentYear }} CaseMGR Solutions, Inc. All Rights Reserved.
      </div>
    </div>
  </div>

  <div v-else>
    <div class="page-content">
      <div class="page-header navbar navbar-fixed-top">
        <div class="page-header-inner">
          <div class="page-logo" style="width: 133px">
            <a href="/" class="">
              <img
                src="/static/layouts/layout2/img/logo-default.png"
                alt="logo"
                class="logo-default"
            /></a>
          </div>
          <div class="page-top"></div>
        </div>
      </div>

      <div class="page-container">
        <div class="container">
          <div class="row main-row">
            <div class="col-12">
              <div class="portlet light">
                <div v-if="sent" class="sent-message">
                  <p v-html="sentMessage"></p>
                  <a :href="downloadUrl" class="btn default create-new-button"
                    >Download Submission</a
                  >
                </div>
                <template v-else>
                  <vue-spinner v-if="loading"></vue-spinner>

                  <div v-else>
                    <vue-form-render
                      ref="formRender"
                      :schema="currentForm.schema"
                      :conditions="currentForm.conditions"
                      :hideValues="currentForm.hideValues"
                      :calculations="currentForm.calculations"
                      :validation-conditions="currentForm.extra_validation_rules"
                      :values="currentForm.values"
                      :date-format="'MM/DD/YYYY'"
                      :user-access-level="1"
                      :name="'shared-form'"
                      :is-participant-submission="true"
                      :formblock="lockFields"
                      :form-previews="currentForm.form_previews"
                    >
                    </vue-form-render>
                    <br />
                    <button
                      class="btn green"
                      @click.prevent="confirmSubmission"
                    >
                      Submit
                    </button>
                  </div>
                </template>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <page-footer></page-footer>
    <shared-form-confirm-modal
      v-if="showSubmissionConfirmModal"
      v-on:display="showSubmissionConfirmModal = $event"
      v-on:confirm="onSubmit"
    ></shared-form-confirm-modal>
  </div>
</template>


<script>
import Footer from "../components/menu/Footer.vue";
import { HTTP, URL } from "@/http-common";
import VueFormRender from "../components/formbuilder/VueFormRender";
import Spinner from "../components/Spinner";
import SharedFormConfirmModal from "../components/modals/SharedFormConfirmModal";

export default {
  name: "ParticipantSharedForm",
  components: {
    VueFormRender,
    SharedFormConfirmModal,
    "page-footer": Footer,
    "vue-spinner": Spinner,
  },

  data() {
    return {
      loading: true,
      currentForm: {
        name: "",
        schema: [],
        conditions: [],
        calculations: [],
        values: [],
        hideValues: [],
        info: [],
        extra_validation_rules: [],
        form_previews: {},
      },
      uid: null,
      maintenance: false,
      maintenanceMessage: "",
      sent: false,
      sentMessage: "",
      invalidForm: false,
      fullUrl: "",
      lockFields: [],
      showSubmissionConfirmModal: false,
    };
  },

  computed: {
    downloadUrl: () => {
      return (
        URL +
        "/shared-forms/download-submission?id=" +
        localStorage.getItem("casemgr_form_submission_token")
      );
    },
    getCurrentYear: function () {
      const d = new Date();
      let year = d.getFullYear();
      return year;
    },
  },

  methods: {
    fetchForm() {
      HTTP.get("shared-forms/get/" + this.uid)
        .then((response) => {
          if (response.data.status === "success") {
            this.currentForm.schema = JSON.parse(response.data.data.form.data);
            this.currentForm.conditions = JSON.parse(
              response.data.data.form.conditionals
            );
            this.currentForm.calculations = JSON.parse(
              response.data.data.form.calculations
            );
            this.currentForm.extra_validation_rules = JSON.parse(
              response.data.data.form.extra_validation_rules
            );
            this.currentForm.hideValues = JSON.parse(
              response.data.data.form.hide_values
            );
            this.currentForm.values = response.data.data.values;
            this.currentForm.form_previews =
              response.data.data.form.form_previews;
            this.maintenance =
              response.data.data.maintenance.maintenance_mode === "on";
            this.maintenanceMessage =
              response.data.data.maintenance.maintenance_message;
            this.lockFields = response.data.data.locked_fields;
            this.invalidForm = false;
          } else {
            this.invalidForm = true;
            this.maintenanceMessage =
              "The link is either incorrect or no longer valid.";
          }
        })
        .catch((error) => {
          this.loading = false;
          this.invalidForm = true;
          this.maintenanceMessage =
            "The link is either incorrect or no longer valid.";
        })
        .finally(() => {
          this.loading = false;
        });
    },
    confirmSubmission() {
      this.showSubmissionConfirmModal = true;
    },

    onSubmit() {
      this.$refs.formRender.submit().then(results => {
        if (results.isValid) {
          this.loading = true;
          const formData = new FormData();

          let allData = {
            data: results.fields,
            uid: this.uid,
          };

          formData.append("data", JSON.stringify(allData));
          results.files.forEach((file, index) => {
            formData.append(file.field + '-' + index, file.file);
          })

          HTTP.post(`/shared-forms/submit`, formData)
            .then((response) => {
              if (response.data.status === "success") {
                this.sent = true;
                this.sentMessage = response.data.data.message;
                this.loading = false;
                localStorage.setItem(
                  "casemgr_form_submission_token",
                  response.data.data.submission_token
                );
                return;
              }
              this.sent = false;
              this.loading = false;
            })
            .catch((err) => {
              this.sent = true;
              this.loading = false;
            });
        }
      })
    },
  },

  mounted() {
    this.uid = this.$route.params.uid;
    this.fullUrl = window.location.href;
    this.fetchForm();
  },
};
</script>

<style scoped lang="scss">
.portlet {
  margin-top: 30px;
}

.page-header {
  @media only screen and (max-width: 767px) {
    .page-top {
      display: none;
    }
    &.navbar {
      height: 68px;
    }
  }
}

.overlay {
  background-color: #ffffff;
  min-height: 100vh;
  min-width: 100vw;
  position: absolute;
}

.brand img {
  width: 100%;
}

.maintenance-body {
  margin-top: 0;
}

.sent-message {
  font-size: 1.4em;
  text-align: center;
  padding: 18vh 0;

  p {
    margin-bottom: 60px;
  }
}

.lock-cont {
  width: 100%;
}
</style>




// WEBPACK FOOTER //
// ParticipantSharedForm.vue?14551e90